<template>
  <div class="row">
    <div class="col-md-10">
      <ul class="block_bikeNotice list-unstyled">
        <li class="notice_diagnosis">
          <router-link to="/service-tools/diagnosis"
                       class="imghoverbox notice_list">
            <span :data-listhead="$t('bikeOverview.diagnosis.diagnosisText')"></span>
          </router-link>
        </li>
        <li class="notice_update">
          <router-link to="/service-tools/update"
                       class="imghoverbox notice_list">
            <span :data-listhead="$t('bikeOverview.update.updateText')"></span>
            <ul class="list_contentUpdate list-unstyled">
              <li v-if="boolHasAvailable">{{ $t('bikeOverview.update.available') }}：{{ getLastestFwVer.length }}</li>
              <li v-else>{{ $t('bikeOverview.update.ebikeIsUpToDate') }}</li>
            </ul>
            <ul class="list-inline" v-if="boolHasAvailable">
              <li v-for="(update, index) in getLastestFwVer"
                  :key="index">{{$t('update.table.device.'+(update.Part).toLowerCase())}}<span v-if="index+1!==getLastestFwVer.length">,</span>
              </li>
            </ul>
            <ul class="list-inline" v-else>
              <li>{{ $t('bikeOverview.update.lastChecked') }}:<p>{{ checkUpdateDateTime }}</p></li>
            </ul>
          </router-link>
        </li>
        <li class="notice_maintenance">
          <ul class="notice_list list-unstyled"
              :data-listhead="$t('bikeOverview.maintenance.maintenanceText')">
            <li :data-title="$t('bikeOverview.maintenance.current')"
                :class="{red:isExpired}">
              {{ getAllBikeInfoList.bikeInfoList ? getAllBikeInfoList.bikeInfoList.ODO : '--' }}
              km <span v-if="funcIsInRangeODO () && funcOverRange ()"> {{$t('bikeOverview.maintenance.expired')}}</span></li>
            <li :data-title="$t('bikeOverview.maintenance.next')">
              {{ Math.floor(getAllBikeInfoList.bikeInfoList ? getAllBikeInfoList.bikeInfoList.NextMaintenance : '--') }} km
            </li>
          </ul>
        </li>
      </ul>
      <div class="list_errorTable mt50">
        <h4>
          <i class="icon-errorcode"></i>{{ $t('bikeOverview.history.errorText') }}
        </h4>
        <v-client-table v-if="tableData.length !== 0"
                        :data="tableData || []"
                        :columns="columns"
                        :options="options">
          <template slot="ErrorCode"
                    slot-scope="props">
            <template>
              {{ $t('bikeOverview.history.error') }} {{ props.row.ErrorCode }}： {{ props.row.ErrPartsName }}
            </template>
          </template>
          <template slot="Description"
                    slot-scope="props">
            <template>
              {{ props.row.ErrPartDesc }}
            </template>
          </template>
        </v-client-table>
        <table class="table table_bike_noerror" v-else>
          <thead>
            <tr>
              <th scope="col">{{ $t('bikeOverview.history.serviceODO') }}</th>
              <th scope="col">{{ $t('bikeOverview.history.errorCode') }}</th>
              <th scope="col">{{ $t('bikeOverview.history.desc') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="3">
                <div class="box_noError">
                  <img src="@/assets/images/bikeoverview/no-error.png" alt="">
                  <p>{{ $t('bikeOverview.history.noErrorFounds') }}<br/>{{ $t('bikeOverview.history.goodCondition') }}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="col-md-12">
      <!-- e-bike area -->
      <div class="row">
        <div class="col-xs-12 mt50">
          <h3 class="title_underLine">{{ $t('bikeOverview.bikeInformation.eBike.eBikeText') }}</h3>
        </div>
        <div class="col-sm-4">
          <h5 class="title_base">{{ $t('bikeOverview.bikeInformation.eBike.bike.bikeText') }}</h5>
          <bike-info-item :listStyled="strListStyled"
                          :infolists="arrBikeInfo"></bike-info-item>
        </div>
        <div class="col-sm-8">
          <h5 class="title_base">{{ $t('bikeOverview.bikeInformation.eBike.supportLevels.supportLevelsText') }}</h5>
          <div class="chartBoxSetting">
            <bike-info-item :listStyled="strPieStyled"
                            :infolists="arrSupportInfo"></bike-info-item>
            <ve-pie height="250px"
                    :data="chartData"
                    :colors="colors"
                    :settings="chartSettings"
                    :tooltip="tooltip"
                    :legend="legend"
                    :extend="chartExtend"></ve-pie>
          </div>
        </div>
      </div>
      <!-- battery area -->
      <div class="row">
        <div class="col-xs-12 mt50">
          <h3 class="title_underLine">{{ $t('bikeOverview.bikeInformation.eBike.battery.batteryText') }}</h3>
        </div>
        <div class="col-xs-12">
          <bike-info-item :listStyled="strListBattery"
                          :infolists="arrBatteryInfo"></bike-info-item>
        </div>
      </div>
      <!-- e-system area -->
      <div class="row">
        <div class="col-xs-12 mt50">
          <h3 class="title_underLine">{{ $t('bikeOverview.bikeInformation.eSystem.eSystemText') }}</h3>
        </div>
        <bike-info-sys-item :arrSystemTemp="tempVal"
                            v-for="(tempVal, index) in arrSystemTemps"
                            :key="index"></bike-info-sys-item>
      </div>
      <!-- smart parts area -->
      <div class="row mb60">
        <div class="col-xs-12 mt50">
          <h3 class="title_underLine">{{ $t('bikeOverview.bikeInformation.smartPart.smartPartText') }}</h3>
        </div>
        <div class="col-sm-4">
          <h5 class="title_base">{{ $t('bikeOverview.bikeInformation.smartPart.smartLock') }}</h5>
          <bike-info-item :listStyled="strListStyled"
                          :infolists="arrLookSmart"></bike-info-item>
        </div>
        <div class="col-sm-4">
          <h5 class="title_base">{{ $t('bikeOverview.bikeInformation.smartPart.tpms') }}</h5>
          <bike-info-item :listStyled="strListStyled"
                          :infolists="arrTpmsSmart"></bike-info-item>
        </div>
      </div>
    </div>

    <Loading :loadingText="$t('loading.loadingText')"
             v-if="boolLoading" />
    <uiv-modal v-model="modalOpen"
               class="v-modal-style"
               :backdrop="!boolDisconnect">
      <h4 slot="header"
          class="modal-title">{{ modal.data.title }}</h4>
      <p slot="default">{{ modal.data.content }}</p>
      <template slot="footer">
        <button type="button"
                id="btnOK"
                class="btn btn-default"
                @click="funcOpenDialog">{{ modal.btn.ok }}</button>
        <button v-show="isHideBtn"
                id="btnCancel"
                type="button"
                class="btn btn-default"
                @click="funcCloseDialog">{{ modal.btn.cancel }}</button>
      </template>
    </uiv-modal>

    <!-- Error Dialog -->
    <uiv-modal v-model="modalOpenDisconnect"
               class="v-modal-style">
      <h4 slot="header"
          class="modal-title">{{ modal.data.title }}</h4>
      <p slot="default">{{ modal.data.content }}</p>
      <template slot="footer">
        <button id="btnOK"
                type="button"
                class="btn btn-default"
                @click="funcOkBtnDialog">{{ modal.btn.ok }}</button>
      </template>
    </uiv-modal>
  </div>
</template>
<script>
/* global $ */

import BikeInfoItem from '@/views/service-tools/bike-overview/components/BikeInfoItem';
import BikeInfoSysItem from '@/views/service-tools/bike-overview/components/BikeInfoSysItem';
import Loading from '@/components/Loading.vue';
import { funcEncryptData, funcDecryptData } from '@/utils/crypt';
import { websocketAPI, bikeOverviewAPI } from '@/mixins/websocket-api';
import { funcErrorCodeMap } from '@/utils/web-style/web-style';
import { objHealthClass, funcGetHealthLevel } from '@/utils/batteryHealth';
import * as connectBikeAPI from '@/api/connect-bike';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { GMTtoLocalTime } from '@/utils/date-format';
import { checkIsGorillaPN } from '@/utils/allowPartNo';

export default {
  name: 'BikeOverview',
  mixins: [websocketAPI, bikeOverviewAPI],
  data () {
    this.chartExtend = {
      series: {
        center: ['50%', '40%'],
        itemStyle: {
          opacity: 1,
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    };
    this.chartSettings = {
      labelLine: { show: false },
      label: {
        show: false
      },
      radius: 80,
      hoverAnimation: false
    };
    this.legend = {
      show: false
    };
    this.tooltip = {
      formatter (e) {
        return e.name + ': ' + e.value + '%';
      }
    };
    return {
      colors: ['#e9ebec', '#909295', '#6c787e', '#3d464a', '#2d2d2d'],
      chartData: {
        columns: ['name', 'value'],
        rows: [
          { name: this.$t('bikeOverview.bikeInformation.eBike.supportLevels.noAssistance'), value: '' },
          { name: this.$t('bikeOverview.bikeInformation.eBike.supportLevels.eco'), value: '' },
          { name: this.$t('bikeOverview.bikeInformation.eBike.supportLevels.tour'), value: '' },
          { name: this.$t('bikeOverview.bikeInformation.eBike.supportLevels.sport'), value: '' },
          { name: this.$t('bikeOverview.bikeInformation.eBike.supportLevels.highSpeed'), value: '' }
        ]
      },
      columns: ['ServiceODO', 'ErrorCode', 'Description'],
      options: {
        headings: {
          ServiceODO: 'KM',
          ErrorCode: 'Error',
          Description: 'Description'
        },
        filterable: false,
        sortable: 'ServiceODO',
        sortIcon: {
          base: 'fa',
          up: 'fa-caret-up',
          down: 'fa-caret-down',
          is: 'fa-caret-down'
        },
        skin: 'table table_base table_AccordionBike',
        texts: { count: '' },
        orderBy: {
          ascending: false,
          column: 'ServiceODO'
        },
        unqiueKey: 'ErrorCode'
      },
      isExpired: false,
      strListBattery: 'bikeinfo_list list_battery',
      strListStyled: 'bikeinfo_list',
      strPieStyled: 'chart_pieStyleData',
      arrSystemTemps: [],
      arrBikeInfo: [],
      arrBatteryInfo: [],
      arrMode: [],
      arrSupportInfo: [],
      arrDisplaySystem: [],
      arrConsoleSystem: [],
      arrDriveSystem: [],
      arrBatterySystem: [],
      arrLookSmart: [],
      arrTpmsSmart: [],
      objError: {
        KM: '--',
        ErrCode: '--'
      },
      modalOpen: false,
      modalOpenDisconnect: false,
      modal: {
        data: {
          title: this.$t('bikeOverview.modalTitle'),
          content: this.$t('bikeOverview.modalContent')
        },
        btn: {
          ok: this.$t('bikeOverview.modalBtnOk'),
          cancel: this.$t('bikeOverview.modalBtnCancel')
        }
      },
      objBikeInfo: {},
      arrAllHisData: [],
      arrFwList: [],
      boolDisconnect: false,
      boolNotRegisted: true,
      loadData: {
        arrBikeInfoData: false,
        arrBatteryInfoData: false,
        arrSupportInfoData: false,
        arrSystemTempsData: false,
        // arrLookSmartData: false,
        objErrorData: false
      },
      checkUpdateDateTime: '--'
    };
  },
  components: {
    BikeInfoItem,
    BikeInfoSysItem,
    Loading
  },
  watch: {
    arrSupportInfo (data) {
      let dataLength = data.length;
      this.chartData.rows.forEach((item, index) => {
        let num = 0;
        if (index < dataLength) {
          let dataContent = data[index].content;
          num = dataContent.slice(0, dataContent.length - 1);
        }
        item['value'] = Number(num);
      });
    },
    getLang (val) {
      let arrMode = ['noAssistance', 'eco', 'tour', 'sport', 'highSpeed'];
      let intLengthArrMode = arrMode.length;
      for (let i = 0; i < intLengthArrMode; i++) {
        let strModeName = arrMode[i];
        this.chartData.rows[i].name = this.$t('bikeOverview.bikeInformation.eBike.supportLevels.' + strModeName);
      }

      // History table title
      this.options.headings.ServiceODO = this.$t('bikeOverview.history.serviceODO');
      this.options.headings.ErrorCode = this.$t('bikeOverview.history.errorCode');
      this.options.headings.Description = this.$t('bikeOverview.history.desc');
    }
  },
  computed: {
    boolLoading () {
      // 註冊拿掉
      return Object.values(this.loadData).includes(false);
    },
    deviceInfo () {
      // 取得firmware 版本值
      return [
        this.getDeviceInfo.ConsolePN,
        this.getDeviceInfo.DisplayPN,
        this.getDeviceInfo.DriverPN
      ];
    },
    ...mapGetters({
      getBikeId: 'bikeConnect/getBikeId',
      getDeviceInfo: 'bikeConnect/getDeviceInfo',
      getLang: 'bikeConnect/getLang',
      getCurrentDate: 'bikeConnect/getCurrentDate',
      getAllBikeInfoList: 'bikeInformation/getAllBikeInfoList',
      getBikeSystemInfo: 'bikeInformation/getBikeSystemInfo'
    }),
    isHideBtn () {
      return !this.boolDisconnect;
    },
    getLastestFwVer () {
      // 取得最新版本
      const lastestFwVer = this.funcHandleLastestFwVer(this.arrFwList, this.arrSystemTemps);
      this.$store.dispatch('bikeInformation/addBikeUpdatedFwVer', lastestFwVer);
      return lastestFwVer;
    },
    getNeedUpdatePart () {
      let arrParts = [];
      this.getLastestFwVer.forEach((item) => {
        arrParts.push(item.Part);
      });
      return arrParts.join(',');
    },
    tableData () {
      const errorCodeList = this.funcErrCodeFormat(this.getAllBikeInfoList.errorCodeList);
      const arr = [];
      this.funcPushArr(arr, ...errorCodeList);

      return arr.filter((item, index) => {
        return index < 8;
      });
    },
    bikesInfoList () {
      return {
        ODO: this.getAllBikeInfoList.bikeInfoList ? this.getAllBikeInfoList.bikeInfoList.ODO : '--', // 現在的ODO
        NextODO: this.getAllBikeInfoList.bikeInfoList ? this.getAllBikeInfoList.bikeInfoList.NextMaintenance : '--' // Setting的Next ODO
      };
    },
    boolHasAvailable () {
      // 如是 Gorilla 則不顯示更新項目
      if (checkIsGorillaPN(this.getDeviceInfo.ConsolePN)) {
        this.checkUpdateDateTime = moment().format('MM/DD/YYYY HH:mm');
        return false;
      }
      return (this.getLastestFwVer.length > 0);
    }
  },
  methods: {
    funcErrCodeFormat (data) {
      if (data !== null) {
        let dataLeng = data.length;
        let arrErrorMap = [];
        for (let i = 0; dataLeng > i; i++) {
          const errorCode = data[i].ErrCode;
          const objErrorMap = funcErrorCodeMap(errorCode);
          let objNewErrorMap = {
            KM: data[i].KM,
            ErrCode: errorCode,
            Category: objErrorMap,
            Desc: objErrorMap.desc
          };
          arrErrorMap.push(objNewErrorMap);
        }
        return arrErrorMap.map((item) => {
          return {
            ServiceODO: item.KM,
            ErrorCode: item.ErrCode,
            ErrPartsName: this.$t('errorCodeMaps.categorys.' + item.Category),
            ErrPartDesc: this.$t('errorCodeMaps.descriptions.' + item.ErrCode)
          };
        });
      } else return [];
    },
    funcShowDetail (e) {
      $(e.target).parent().children('.timeline_tableInfo').slideToggle('500');
      $(e.target).toggleClass('clicked');
    },
    funcHisDateFormat (data, index) {
      let localTime = GMTtoLocalTime(data);
      return localTime.split(' ')[index];
    },
    funcHandleLastestFwVer (lastestFw, currentFw) {
      this.checkUpdateDateTime = moment().format('MM/DD/YYYY HH:mm');
      return lastestFw.filter(o1 => {
        return currentFw.some(o2 => {
          // PartType === Type
          if (o1.PartType === o2.Type) {
            return this.funcCheckFWVer(o1.HasData, o1.PartType, o2.FwVer, o1.LatestFW);
          }
        });
      });
    },
    funcCheckFWVer (hasData, partType, currentVer, lastVer) {
      let isUpdate = false;
      switch (partType) {
        case 'C':
          isUpdate = this.funcIsCouldUpdatedHY(hasData, currentVer, lastVer);
          break;
        case 'D':
          isUpdate = this.funcIsCouldUpdatedHY(hasData, currentVer, lastVer);
          break;
        case 'M':
          isUpdate = this.funcIsCouldUpdatedBR(hasData, currentVer, lastVer);
          break;
        case 'P':
          isUpdate = this.funcIsCouldUpdatedHY(hasData, currentVer, lastVer);
          break;
        default:
          isUpdate = false;
      }
      return isUpdate;
    },
    funcIsCouldUpdatedBR (hasData, currentVer, lastVer) {
      if (!hasData) return false;
      if (currentVer === '--' && hasData) return true;
      if (currentVer.split(':')[1] < lastVer.split(':')[1]) return true;
      return false;
    },
    funcIsCouldUpdatedHY (hasData, currentVer, lastVer) {
      let currentFirstChar = currentVer.substr(0, 1);
      let lastFirstChar = lastVer.substr(0, 1);
      if (!hasData) return false;
      if (currentFirstChar !== lastFirstChar) return false;
      if (currentVer.substr(1) < lastVer.substr(1)) return true;
      return false;
    },
    funcBindSmartParts (data) {
      let arr = [];
      const objApiData = {
        SmartLocl: 'smartPart.installed',
        FrontTpms: 'smartPart.installed_FT',
        RearTpms: 'smartPart.installed_RT'
      };

      if (data.Status === 1000) {
        for (let dataKey in objApiData) {
          let strApiData = {
            name: objApiData[dataKey],
            content: data[dataKey] === 1 ? 'smartPart.yes' : 'smartPart.no',
            lang: true
          };
          arr.push(strApiData);
        }
        this.arrLookSmart = [].concat(arr[0]);
        this.arrTpmsSmart = [].concat(arr[1], arr[2]);
      }
    },
    async funcGetBikeLatestFW (SystemInfo) {
      // Part No 獲得最新FW的版本資訊
      const encryptData = funcEncryptData({ PartNoList: this.deviceInfo });
      const data = await connectBikeAPI.getBikeLatestFW(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      // console.log("TCL: funcGetBikeLatestFW -> data", data)

      if (data.ErrorCode === 0) {
        this.arrFwList = data.FwList;
        this.funcBindBikeArrTemp(SystemInfo);
      }
      // console.log("最後版本")
    },
    funcOpenDialog () {
      if (this.boolDisconnect) {
        this.modalOpen = false;
        this.$router.push('/connect');
      } else {
        this.modalOpen = false;
        this.$router.push('/service-tools/bike-overview/register/privacy');
      }
    },
    funcCloseDialog () {
      this.modalOpen = false;
    },
    funcOkBtnDialog () {
      this.modalOpenDisconnect = false;
      this.$router.push('/connect');
    },
    funcBindBikeErrorCode (data) {
      const arrLeng = data.ErrorCodeList.length;
      this.$store.dispatch('bikeInformation/addErrorCodeList', data.ErrorCodeList);

      if (arrLeng === 0) {
        this.loadData.objErrorData = true;
        return;
      }
      const objErrorData = data.ErrorCodeList[arrLeng - 1];
      this.objError.KM = objErrorData.KM;
      this.objError.ErrCode = objErrorData.ErrCode;
      this.loadData.objErrorData = true;
    },
    funcBindBikeInfo (data) {
      // no get value
      // 特別處理 -- 是DB
      this.$store.dispatch('bikeInformation/addBikeInfoList', data);
      const arr = [];

      const objNodataLc = {
        name: 'eBike.bike.lastConnection',
        content: this.getCurrentDate
      };
      arr.push(objNodataLc);

      // Message Getway
      const objApiData = {
        ODO: 'eBike.bike.odo',
        MaxSpeed: 'eBike.bike.maxSpeed',
        AvgSpeed: 'eBike.bike.avgSpeed'
      };

      for (let dataKey in objApiData) {
        let strApiData = {
          name: objApiData[dataKey],
          content: data[dataKey]
        };
        arr.push(strApiData);
      }

      this.arrBikeInfo = [].concat(arr);
      this.loadData.arrBikeInfoData = true;
    },
    funcBindBikeBattery (data) {
      // no get value
      const arr = [];
      this.$store.dispatch('bikeInformation/addBikeBatteryInfo', data);

      // Message Getway
      const objApiData = {
        SerialNo: 'eBike.battery.serialNumber',
        RSOC: 'eBike.battery.stateOfCharge',
        productDate: 'eBike.battery.productDate',
        CycleCount: 'eBike.battery.chargeCycles',
        DesignCapacity: 'eBike.battery.capacity',
        LongestDaysNoCharge: 'eBike.battery.withoutCharge',
        Health: 'eBike.battery.stateOfHealth',
        ActVoltage: 'eBike.battery.voitage'
      };

      for (let dataKey in objApiData) {
        let contentClass = '';
        let contentData = '';
        let contentLang = false;
        let contentTextKey = data[dataKey];

        if (dataKey === 'productDate') {
          const productYear = data.ProductionDateYear;
          const productMonth = data.ProductionDateMonth;
          if (productYear === '--') {
            contentTextKey = productMonth + ' / ' + productYear;
          } else {
            contentTextKey = productMonth + ' / ' + '20' + productYear;
          }
        }

        if (dataKey === 'DesignCapacity') contentTextKey = contentTextKey + ' Wh';
        if (dataKey === 'RSOC') contentTextKey = contentTextKey + ' %';
        if (dataKey === 'LongestDaysNoCharge') contentTextKey = contentTextKey + ' Days';
        if (dataKey === 'ActVoltage') contentTextKey = contentTextKey + ' Volts';

        if (dataKey === 'Health') {
          const batteryHealth = data.Health;
          if (batteryHealth === '--') {
            contentTextKey = batteryHealth + '%';
            contentData = '';
            contentClass = '';
            contentLang = false;
          } else {
            contentTextKey = this.funcHealthName(contentTextKey);
            contentData = batteryHealth + '% ';
            let strHealthLevel = funcGetHealthLevel(data[dataKey]);
            contentClass = objHealthClass[strHealthLevel];
            contentLang = true;
          }
        }

        let strApiData = {
          name: objApiData[dataKey],
          content: contentTextKey,
          otherData: contentData,
          class: contentClass,
          lang: contentLang
        };
        arr.push(strApiData);
      }
      this.funcPushArr(this.arrBatteryInfo, ...arr);
      this.loadData.arrBatteryInfoData = true;
    },
    funcBindBikeSupport (data) {
      this.arrMode = data.AssistMode;
      const strModeLeng = this.arrMode.length;
      const strKmAll = this.funcSumkm(strModeLeng);
      const arr = [];
      this.funcPerkm(strKmAll);

      for (let i = 0; strModeLeng > i; i++) {
        let objApiData = {
          name: this.funcModeName(this.arrMode[i].Mode),
          content: this.arrMode[i].Percent.toFixed(2) + '%',
          otherData: this.arrMode[i].DistencePerWattHour + 'Wh/km'
        };
        if (i === 0) objApiData.otherData = '';
        arr.push(objApiData);
      }
      this.funcPushArr(this.arrSupportInfo, ...arr);
      this.loadData.arrSupportInfoData = true;
    },
    funcBindBikeArrTemp (data) {
      const arrEsysLeng = data.FwList.length;
      const arrEsys = data.FwList;
      const arr = [];
      this.$store.dispatch('bikeInformation/addBikeSystemInfo', data);

      for (let i = 0; arrEsysLeng > i; i++) {
        arr.push(arrEsys[i]);
      }
      this.funcPushArr(this.arrSystemTemps, ...arr);
      this.funcDealPartName(this.arrSystemTemps);
      this.loadData.arrSystemTempsData = true;
    },
    funcDealPartName (listFw) {
      listFw.forEach((item) => {
        item.PartName = this.funcGetPartName(item.Type);
      });
    },
    funcGetPartName (partType) {
      let partName = '--';
      this.arrFwList.forEach((item) => {
        if (item.PartType === partType) {
          partName = item.PartName;
        }
      });
      return partName;
    },
    funcSumkm (strModeLeng) {
      let sum = 0;
      for (let i = 0; strModeLeng > i; i++) {
        sum += this.arrMode[i].KM;
      }
      return sum;
    },
    funcPerkm (total) {
      const per = 100;
      if (total > 0) {
        this.arrMode.forEach(
          function (objItem) {
            objItem.Percent = (objItem.KM / total) * per;
          }
        );
      } else {
        this.arrMode.forEach(
          function (objItem) {
            objItem.Percent = 0 * per;
          }
        );
      }
    },
    funcModeName (name) {
      switch (name.toString()) {
        case '0':
          return 'eBike.supportLevels.noAssistance';
        case '1':
          return 'eBike.supportLevels.eco';
        case '2':
          return 'eBike.supportLevels.tour';
        case '3':
          return 'eBike.supportLevels.sport';
        case '4':
          return 'eBike.supportLevels.highSpeed';
      }
    },
    funcHealthName (data) {
      // 電池健康度, 回傳語系 Key 值
      if (data >= 76 && data <= 100) return 'eBike.battery.health.good';
      else if (data >= 51 && data <= 75) return 'eBike.battery.health.average';
      else if (data <= 50) return 'eBike.battery.health.bad';
      else return data;
    },
    funcPushArr (arr, ...item) {
      // 主要是return 新的陣列
      arr.push(...item);
    },
    funcIsInRangeODO () {
      const current = this.bikesInfoList.ODO;
      const next = this.bikesInfoList.NextODO;
      let mathResult = Math.abs(next - current);
      let rangeVal = 10;
      if (mathResult >= rangeVal) {
        return true;
      } else {
        return false;
      }
    },
    funcOverRange () {
      const current = this.bikesInfoList.ODO;
      const next = this.bikesInfoList.NextODO;
      let mathResult = current - next;
      let rangeVal = 10;
      if (mathResult > rangeVal) {
        this.isExpired = true;
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
